import { Injectable } from '@angular/core';
import { filterNilValue, Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { NotificationStatus, NotificationType, Notification } from './notification.model';
import { NotificationState, NotificationStore } from './notification.store';

export const VIEW_NOTIFICATION_TYPES: NotificationType[] = [
  NotificationType.JoinRequest,
  NotificationType.JoinEventRequestAccepted,
  NotificationType.RequestReject,
  NotificationType.Review,
  NotificationType.RemovedFromGame,

  NotificationType.JoinGroupRequestReceived,
  NotificationType.JoinGroupRequestAccepted,
  NotificationType.JoinGroupRequestRejected,
  NotificationType.RemovedFromGroup,
];

@Injectable()
@QueryConfig({
  sortBy: 'createdAt',
  sortByOrder: Order.ASC
})
export class NotificationQuery extends QueryEntity<NotificationState> {
  notifications$ = this.selectAll();

  viewNotifications$ = this.notifications$.pipe(
    map((notifications) => {
      return notifications.filter(
        ({ type, status, relatedDocument }) =>
          relatedDocument &&
          VIEW_NOTIFICATION_TYPES.includes(type) &&
          status === NotificationStatus.New
      );
    })
  );

  viewOldNotifications$ = this.notifications$;
  unreadCount$ = this.viewNotifications$.pipe(map((n) => n.length));

  constructor(protected store: NotificationStore) {
    super(store);
  }

  on(type: NotificationType): Observable<Notification> {
    return this.selectLast().pipe(
      filterNilValue(),
      filter((notification) => notification?.type === type),
      distinctUntilChanged((x, y) => !x || !y || x.id !== y.id)
    );
  }
}
